import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { ApiEndpoints } from 'meta/api'
import { FeatureCollectionPhotoPoint } from 'meta/photo/photoPoint'
import { Project } from 'meta/project/project'

// Define a service using a base URL and expected endpoints
export const projectsApi = createApi({
  reducerPath: 'projects',
  baseQuery: fetchBaseQuery(),
  endpoints: (build) => ({
    getPhotoPoints: build.query<FeatureCollectionPhotoPoint, { projectName: Project['name'] }>({
      query: ({ projectName }) => ApiEndpoints.Projects.photoPoints(projectName),
    }),
  }),
})
